import React from 'react';
import {
  Link,
  CardContent,
  List,
  ListItem,
  Badge,
  Popover,
  Icon,
  Card
} from 'framework7-react';
import { DOC_TYPE_SIGNATURE } from '../helpers/utils';
import II18 from '../translate/II18';
import PropTypes from 'prop-types';
import { prepareListInfo } from './Elements';

class MobileDocEntry extends React.Component {
  render = () => {
    const {
      document,
      scannedPages,
      forms,
      documentsStatus,
      scanEnded,
      onMobileUploadClick,
      navigateToViewer,
      successSentKeys,
      errorSentKeys,
      animateEntry
    } = this.props;

    const {
      mobileIcon,
      hasScannedPages,
      documentReady,
      badge,
      submitted,
      hasProblem,
      rejected
    } = prepareListInfo(
      document,
      scannedPages,
      forms,
      documentsStatus,
      successSentKeys,
      errorSentKeys,
      scanEnded
    );

    const showSignatureSubMenu =
      document.type === DOC_TYPE_SIGNATURE && hasScannedPages;
    const signaturePopoverClass = 'popover-signature-' + document.id;
    const popoverId = showSignatureSubMenu ? '.' + signaturePopoverClass : '';

    return (
      <Card className={'paperfly-card'}>
        <CardContent padding={false}>
          <List medial-list>
            <ListItem
              tooltip={document.name.length > 25 ? document.name : ''}
              id={'documentEntryAction_' + document.id}
              className={
                (hasProblem ? ' doc-problem ' : '') +
                (animateEntry ? ' pulse ' : '') +
                'documentRow_' +
                document.type +
                ' documentEntryAction_' +
                document.type +
                ' mobileEntry document-' +
                document.id +
                (documentReady && ' ready ') +
                (submitted && ' submitted ') +
                (rejected && ' rejected ') +
                (document.optional && ' optional')
              }
              onClick={() => {
                if (showSignatureSubMenu) {
                  this.$f7.popover.open(
                    popoverId,
                    '.document-' + document.id,
                    true
                  );
                } else {
                  onMobileUploadClick(document);
                }
              }}
              noChevron
            >
              <label slot="title" style={{ marginRight: 10 }}>
                {` ${document.name}`}
              </label>
              {document.optional && (
                <Badge
                  style={{
                    fontSize: 10,
                    lineHeight: 15,
                    minWidth: 55,
                    pointerEvents: 'none'
                  }}
                  slot="after-title"
                >
                  optional
                </Badge>
              )}

              {
                <Link
                  slot="after"
                  popoverOpen={popoverId ? popoverId : false}
                  href={false}
                  iconColor={submitted ? 'gray' : 'gray'}
                  iconMd={mobileIcon.md}
                  iconIos={mobileIcon.ios}
                  iconBadge={
                    badge === true ? (
                      <Icon
                        material={'done'}
                        size={13}
                        style={{ position: 'absolute' }}
                      />
                    ) : (
                      badge
                    )
                  }
                  badgeColor="blue"
                />
              }
              {showSignatureSubMenu && (
                <Popover className={signaturePopoverClass}>
                  <List>
                    <ListItem
                      popoverClose
                      title={II18.get(
                        documentReady
                          ? 'list_item_scanned_document'
                          : 'list_item_scann_next'
                      )}
                      onClick={() => {
                        this.$f7.popover.close(popoverId);
                        onMobileUploadClick(document);
                      }}
                    >
                      <Icon
                        slot="after"
                        md="material:collections"
                        ios="f7:rectangle_stack"
                      />
                    </ListItem>
                    <ListItem
                      popoverClose
                      title={II18.get('list_item_original_document')}
                      onClick={() => {
                        this.$f7.popover.close(popoverId);
                        navigateToViewer(document.id);
                      }}
                    >
                      <Icon
                        slot="after"
                        md="f7:document_text"
                        ios="f7:document_text"
                      />
                    </ListItem>
                  </List>
                </Popover>
              )}
            </ListItem>
          </List>
        </CardContent>
      </Card>
    );
  };
}

MobileDocEntry.propTypes = {
  document: PropTypes.object,
  scannedPages: PropTypes.object,
  forms: PropTypes.object,
  documentsStatus: PropTypes.object,
  scanEnded: PropTypes.bool,
  onMobileUploadClick: PropTypes.func,
  navigateToViewer: PropTypes.func,
  successSentKeys: PropTypes.object,
  errorSentKeys: PropTypes.object,
  animateEntry: PropTypes.bool
};

export default MobileDocEntry;
